import { useNavigate } from "react-router-dom";

import useActiveWorkspace from "@/hooks/useActiveWorkspace";

/** In-app and external link navigation for tool result buttons (shared workspace path prefixing). */
export const useWorkspaceToolNavigation = () => {
  const navigate = useNavigate();
  const workspace = useActiveWorkspace();

  return (url: string, method: "push" | "replace") => {
    const isExternalUrl = url.startsWith("http://") || url.startsWith("https://");
    if (isExternalUrl) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    const hasWorkspacePath = url.startsWith("/workspace/");
    const workspaceId = workspace?.id;
    let fullUrl = url;
    if (!hasWorkspacePath && workspaceId) {
      fullUrl = `/workspace/${workspaceId}${url}`;
    }

    if (method === "replace") {
      navigate(fullUrl, { replace: true });
    } else {
      navigate(fullUrl);
    }
  };
};
